import { type SiteVersion } from '../../api/site-version'
import { type Action, type UnknownAction, isKnownAction } from '../actions'

export type State = SiteVersion | null

export function getInitialState(siteVersion: SiteVersion | null = null): State {
  return siteVersion
}

export function getSiteVersion(state: State): SiteVersion | null {
  return state
}

export function reducer(state = getInitialState(), action: Action | UnknownAction): State {
  if (!isKnownAction(action)) return state

  switch (action.type) {
    default:
      return state
  }
}
